<template>
  <transition name="modal">
    <div v-if="active" class="modal-mask" @click="close()">
      <div
        ref="signupmodalwrapper"
        class="modal__body qes-modal-body modal-container home-email-modal modal-wrapper"
        style="background: none"
        role="dialog"
        aria-label="Rare finds, and the stories behind them. Delivered to your inbox daily."
        analytics-track="quickregPrompt"
      >
        <div
          id="modal10pc"
          style="margin: 0 auto"
          @keyup.esc="close()"
          @click.stop
        >
          <div id="modal10pc-close" @click="close()" @keydown.esc="close()">
            <img
              src="data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI1NC4yNDMiIGhlaWdodD0iNTQuMjQzIiB2aWV3Qm94PSIwIDAgNTQuMjQzIDU0LjI0MyI+DQogIDxnIGlkPSJHcm91cF8xNCIgZGF0YS1uYW1lPSJHcm91cCAxNCIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTQ3Ljg3OSAtNDcuODc5KSI+DQogICAgPGcgaWQ9Ikdyb3VwXzgiIGRhdGEtbmFtZT0iR3JvdXAgOCI+DQogICAgICA8bGluZSBpZD0iTGluZV8xIiBkYXRhLW5hbWU9IkxpbmUgMSIgeDI9IjUwIiB5Mj0iNTAiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDUwIDUwKSIgZmlsbD0ibm9uZSIgc3Ryb2tlPSIjMDAwIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS13aWR0aD0iMyIvPg0KICAgICAgPGxpbmUgaWQ9IkxpbmVfMiIgZGF0YS1uYW1lPSJMaW5lIDIiIHgxPSI1MCIgeTI9IjUwIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSg1MCA1MCkiIGZpbGw9Im5vbmUiIHN0cm9rZT0iIzAwMCIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2Utd2lkdGg9IjMiLz4NCiAgICA8L2c+DQogIDwvZz4NCjwvc3ZnPg0K"
            />
          </div>
          <h4>Enjoy 10% Off Your First Order</h4>
          <p style="margin-bottom: 90px">
            Join us on the wine trail for every story we tell.
          </p>
          <FormulateForm class="wine-trail-email" @submit="registerQes">
            <div class="d-flex">
              <div class="input-wrapper w-md-50">
                <label class="sr-only" for="signup-email">Email</label>
                <FormulateInput
                  id="signup-email"
                  :formulate-value="qesEmail"
                  :autofocus="autoFocus"
                  label="Email Address"
                  type="email"
                  name="qesEmail"
                  validation="required|email"
                  maxlength="255"
                  placeholder="Your email address"
                  error-behavior="submit"
                  @focus="qesShowLabel('signup-email')"
                  @keydown.esc="close()"
                  @blur="
                    () => {
                      if (!qesEmail) {
                        qesHideLabel('signup-email')
                      }
                    }
                  "
                />
              </div>
              <div class="input-wrapper w-md-50">
                <label class="sr-only" for="signup-zip">Zip Code</label>
                <FormulateInput
                  id="signup-zip"
                  v-model="zipcode"
                  type="text"
                  name="zipcode"
                  label="Zip code"
                  placeholder="Zip code"
                  error-behavior="submit"
                  validation="required|matches:/^\d{5}(?:-\d{4})?$/"
                  :validation-messages="{
                    matches: 'Error: You must input a valid US Zip Code',
                  }"
                  @focus="qesShowLabel('signup-zip')"
                  @keydown.esc="close()"
                  @blur="
                    () => {
                      if (!zipcode) {
                        qesHideLabel('signup-zip')
                      }
                    }
                  "
                />
              </div>
            </div>
            <ErrorList :errors="flattenErrorArray(qesErrors)" />
            <FormulateInput
              :disabled="loading"
              class="black"
              type="submit"
              label="Subscribe"
              @keydown.esc="close()"
            />
          </FormulateForm>
        </div>
      </div>
    </div>
  </transition>
</template>
<script>
import ga4 from '#common/utils/ga4'

export default {
  components: {
    ErrorList: defineAsyncComponent(
      () => import('#common/components/ErrorList.vue'),
    ),
  },
  props: {
    autoFocus: {
      type: Boolean,
      required: false,
      default: true,
    },
    active: {
      type: Boolean,
      required: true,
    },
  },
  emits: ['closed', 'register-success'],
  data() {
    return {
      qesEmail: '',
      zipcode: '',
      qesErrors: {},
      loading: false,
    }
  },
  methods: {
    qesShowLabel(inputId) {
      $(`#${inputId}`).parent().siblings('label').addClass('show')
    },
    qesHideLabel(inputId) {
      $(`#${inputId}`).parent().siblings('label').removeClass('show')
    },
    close() {
      if (this.$refs.signupmodalwrapper) {
        this.$refs.signupmodalwrapper.setAttribute('aria-hidden', 'true')
      }
      this.$emit('closed')
    },
    flattenErrorArray(errors) {
      errors = Object.values(errors)
      return errors.map((x) => (Array.isArray(x) ? x.join(' ') : x))
    },
    async registerQes(data) {
      this.qesErrors = {}
      this.loading = true
      try {
        await this.$store.dispatch('registerQes', data)
        this.$emit('register-success')
        ga4.track('register')
        const result = await this.$axios.get('/api/customer/user/')
        this.$auth.setUser(result.data)
      } catch (errors) {
        this.qesErrors = errors.response.data
      }
      this.loading = false
    },
  },
}
</script>
<style lang="scss">
@import '../../assets/scss/components/wineTrailEmailSignup/wine-trail-email-signup';
</style>
